import IncreaseCorporateDT from './IncreaseCorporateDT';
import IncreaseCorporatePR from './IncreaseCorporatePR';
import IncreaseIndividualsDT from './IncreaseIndividualsDT';
import IncreaseIndividualsPR from './IncreaseIndividualsPR';
import updateCorporateDT from './updateCorporateDT';
import updateCorporatePR from './updateCorporatePR';
import updateIndividualPR from './updateIndividualPR';
import updateIndividualDT from './updateIndividualDT';
import PromissoryNoteRefusalUpCorporatePR from './PromissoryNoteRefusalUpCorporatePR';
import PromissoryNoteRefusalUpIndividualPR from './PromissoryNoteRefusalUpIndividualPR';

export const RequiredRules = [
  IncreaseCorporateDT,
  IncreaseCorporatePR,
  IncreaseIndividualsDT,
  IncreaseIndividualsPR,
  updateCorporateDT,
  updateCorporatePR,
  updateIndividualPR,
  updateIndividualDT,
  PromissoryNoteRefusalUpCorporatePR,
  PromissoryNoteRefusalUpIndividualPR,
];
